import { render, staticRenderFns } from "./HomePageSetting.vue?vue&type=template&id=60c9c572&"
import script from "./HomePageSetting.vue?vue&type=script&lang=js&"
export * from "./HomePageSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c9c572')) {
      api.createRecord('60c9c572', component.options)
    } else {
      api.reload('60c9c572', component.options)
    }
    module.hot.accept("./HomePageSetting.vue?vue&type=template&id=60c9c572&", function () {
      api.rerender('60c9c572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/HomePageSetting.vue"
export default component.exports